import { IMappers } from '../../../repositories/billing-tariffs/v1/publish-terms';
import { IGetPublishTermsSuccess, IGetPublishTermsFail } from './types';
import { mapPublishTerms } from './utils';

export const mappers: IMappers<IGetPublishTermsSuccess, IGetPublishTermsFail> = {
  200: response => ({
    success: true,
    payload: mapPublishTerms(response),
  }),
  400: response => ({
    success: false,
    payload: response.message,
  }),
};
